import { useCallback } from "react";
import {
  NodeViewContent,
  NodeViewProps,
  NodeViewWrapper,
} from "@tiptap/react";
import { IconChevronRight, IconHash } from "@tabler/icons-react";
import classes from "./expandable.module.css";

export default function ExpandableView(props: NodeViewProps) {
  const { node, editor, getPos } = props;
  const open: boolean = !!node.attrs.open;
  const id: string | null =
    typeof node.attrs.id === "string" && node.attrs.id ? node.attrs.id : null;

  const toggle = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (typeof getPos !== "function") return;
      const pos = getPos();
      if (pos == null) return;
      const tr = editor.state.tr.setNodeMarkup(pos, undefined, {
        ...node.attrs,
        open: !open,
      });
      editor.view.dispatch(tr);
    },
    [editor, getPos, node.attrs, open],
  );

  const copyLink = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      e.stopPropagation();
      if (!id) return;
      try {
        const url = `${window.location.origin}${window.location.pathname}#${id}`;
        navigator.clipboard?.writeText(url);
      } catch {
        // noop
      }
    },
    [id],
  );

  return (
    <NodeViewWrapper
      className={classes.wrapper}
      data-type="expandable"
      data-open={open ? "true" : "false"}
      id={id ?? undefined}
    >
      <button
        type="button"
        className={classes.chevronBtn}
        onMouseDown={(e) => e.preventDefault()}
        onClick={toggle}
        aria-label={open ? "Collapse" : "Expand"}
        contentEditable={false}
      >
        <IconChevronRight size={16} className={classes.chevronIcon} />
      </button>
      {open && id && (
        <button
          type="button"
          className={classes.anchorBtn}
          onMouseDown={(e) => e.preventDefault()}
          onClick={copyLink}
          aria-label="Copy anchor link"
          contentEditable={false}
        >
          <IconHash size={14} />
        </button>
      )}
      <NodeViewContent className={classes.content} as="div" />
    </NodeViewWrapper>
  );
}
